import {
  StepContext,
  StepEmailVerification,
  StepError,
  StepFinal,
  StepFinalRedirectLogin,
  StepFourForm,
  StepOneForm,
  StepOneSearch,
  StepThreeForm,
  StepTwoForm,
} from '../steps-contents';
import { FooterLogin } from '../steps-contents/step-context';
import { Step, StepConfiguration } from './types';

const stepConfigurations: Record<Step, StepConfiguration> = {
  [Step.STEP_CONTEXT]: {
    Element: StepContext,
    progress: 0,
    nextKey: 'letsgo',
    isFinal: false,
    leftComponent: FooterLogin,
  },
  [Step.STEP_ONE_SEARCH]: {
    Element: StepOneSearch,
    progress: 0,
    nextKey: 'next',
    isFinal: false,
  },
  [Step.STEP_ONE_FORM]: {
    Element: StepOneForm,
    progress: 0,
    nextKey: 'next',
    isFinal: false,
  },
  [Step.STEP_TWO_FORM]: {
    Element: StepTwoForm,
    progress: 1,
    nextKey: 'next',
    previousKey: 'back',
    isFinal: false,
  },
  [Step.STEP_THREE_FORM]: {
    Element: StepThreeForm,
    progress: 2,
    nextKey: 'next',
    previousKey: 'back',
    isFinal: false,
  },
  [Step.STEP_FOUR_FORM]: {
    Element: StepFourForm,
    progress: 3,
    nextKey: 'signUp',
    previousKey: 'back',
    isFinal: false,
  },
  [Step.STEP_EMAIL_VERIFICATION]: {
    Element: StepEmailVerification,
    progress: 4,
    previousKey: 'back',
    isFinal: false,
  },
  [Step.STEP_FINAL]: {
    Element: StepFinal,
    progress: 5,
    isFinal: true,
  },
  [Step.STEP_FINAL_REDIRECT_LOGIN]: {
    Element: StepFinalRedirectLogin,
    progress: 5,
    isFinal: false,
    previousKey: 'back',
  },
  [Step.STEP_ERROR]: {
    Element: StepError,
    progress: 0,
    isFinal: true,
  },
};

export const NUMBER_OF_STEPS = new Set(
  Object.values(stepConfigurations)
    .filter(s => s.progress > 0)
    .map(s => s.progress),
).size;

export function getStepConfiguration(step: Step): StepConfiguration {
  return stepConfigurations[step];
}

export const FIRST_STEP = Step.STEP_CONTEXT;
